import Vue from 'vue';
import { MutationTree } from 'vuex';
import { ListProgress } from '@descomplica/dex-models';
import { ListState } from './state';
import { ListSessionState } from '../listSessions/state';

const mutations: MutationTree<ListState> = {
  SET_LISTS(state, entities: ListState) {
    if (!entities.lists) return;

    Object.values(entities.lists).forEach((list) => {
      Vue.set(state.lists, list.id.toString(), { ...state.lists[list.id], ...list });
    });
  },
  UPDATE_LISTS_WITH_SESSIONS(state, listSessions: ListSessionState) {
    if (listSessions.listSessions) {
      Object.values(listSessions.listSessions).forEach((listSession) => {
        const list = state.lists[listSession.listId.toString()];
        if (!list) return;
        Vue.set(list, 'sessionId', listSession.id);
      });
    }
  },
  SET_LISTS_PROGRESS(state, listsProgresses: ListProgress[]) {
    if (!listsProgresses) return;

    listsProgresses.forEach((listProgress) => {
      Vue.set(state.listsProgressMap, listProgress.listId.toString(), listProgress);
    });
  },
};

export default mutations;
